export default {
	searchParams: {
		eqipKndCd: '',
		mesEqipNm: '',
		mesEqipNo: ''
	},
	mesEqipNoList: [],
	usePlCdList: [], //조회조건에 라인

	pagingInfo: {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	}
};
